import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { IonicModule } from '@ionic/angular';
import { ErrorMessagesComponent } from './error-messages/error-messages.component';
import { LocationPickerComponent } from './location-picker/location-picker.component';
import { ModalLocationPickerComponent } from './modal-location-picker/modal-location-picker.component';
import { ModalSelectCityComponent } from './modal-select-city/modal-select-city.component';
import { NoDataComponent } from './no-data/no-data.component';
import { PasswordToggleComponent } from './password-toggle/password-toggle.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { ProductCategoryBlurbComponent } from './product-category-blurb/product-category-blurb.component';
import { ProductCheckoutComponent } from './product-checkout/product-checkout.component';
import { AlamatCardComponent } from './alamat-card/alamat-card.component';
import { PaymentCardComponent } from './payment-card/payment-card.component';
import { CardTransaksiComponent } from './card-transaksi/card-transaksi.component';
import { EventCardComponent } from './event-card/event-card.component';
import { ProductCardDetailTransaksiComponent } from './product-card-detail-transaksi/product-card-detail-transaksi.component';
import { VoucherCardComponent } from './voucher-card/voucher-card.component';
import { ProductCheckoutLoadingComponent } from './product-checkout/product-checkout-loading/product-checkout-loading.component';
import { PaymentCardLoadingComponent } from './payment-card/payment-card-loading/payment-card-loading.component';
import { AlamatCardLoadingComponent } from './alamat-card/alamat-card-loading/alamat-card-loading.component';
import { ModalPaymentMethodComponent } from './modal-payment-method/modal-payment-method.component';
import { RouterModule } from '@angular/router';
import { MyVoucherCardComponent } from './my-voucher-card/my-voucher-card.component';
import { ModalManualTransferPaymentComponent } from './modal-manual-transfer-payment/modal-manual-transfer-payment.component';
import { StarReviewProductComponent } from './star-review-product/star-review-product.component';
import { ModalSelectWarehouseComponent } from './modal-select-warehouse/modal-select-warehouse.component';
import { CircularProgressbarComponent } from './circular-progressbar/circular-progressbar.component';
import { BlogCardComponent } from './blog-card/blog-card.component';
import { ModalBarcodeComponent } from './modal-barcode/modal-barcode.component';
import { HeaderComponent } from './header/header.component';
import { SectionTitleComponent } from './section-title/section-title.component';
import { HomeProductComponent } from './home-product/home-product.component';
import { ProductReviewItemComponent } from './product-review-item/product-review-item.component';
import { ModalCustomAlertComponent } from './modal-custom-alert/modal-custom-alert.component';
import { ModalSelectStockLocationComponent } from './modal-select-stock-location/modal-select-stock-location.component';
import { ModalSortComponent } from './modal-sort/modal-sort.component';
import { ModalFilterComponent } from './modal-filter/modal-filter.component';
import { ModalSelectCityBranchComponent } from './modal-select-city-branch/modal-select-city-branch.component';
import { ModalQuickselectAlamatComponent } from './modal-quickselect-alamat/modal-quickselect-alamat.component';
import { CategoryCardComponent } from './category-card/category-card.component';
import { NavigatedSearchbarComponent } from './navigated-searchbar/navigated-searchbar.component';
import { WishlistProductCardComponent } from './wishlist-product-card/wishlist-product-card.component';
import { CartItemComponent } from './cart-item/cart-item.component';
import { CheckoutItemComponent } from './checkout-item/checkout-item.component';
import { OrderStepsComponent } from './order-steps/order-steps.component';
import { ModalSelectPickupLocationComponent } from './modal-select-pickup-location/modal-select-pickup-location.component';
import { CopyComponent } from './copy/copy.component';
import { ModalShowPaymentDetailComponent } from './modal-show-payment-detail/modal-show-payment-detail.component';
import { PointHistoryComponent } from './point-history/point-history.component';
import { ModalSelectFilePaymentProofComponent } from './modal-select-file-payment-proof/modal-select-file-payment-proof.component';
import { FakturCardComponent } from './faktur-card/faktur-card.component';
import { ModalGetReasonComponent } from './modal-get-reason/modal-get-reason.component';
import { CountdownComponent } from './countdown/countdown.component';
import { OrderProductsComponent } from './order-products/order-products.component';
import { PopoverWishlistSortFilterComponent } from './popover-wishlist-sort-filter/popover-wishlist-sort-filter.component';
import { VoucherListComponent } from './voucher-list/voucher-list.component';
import { TransactionSummaryComponent } from './transaction-summary/transaction-summary.component';
import { QtyInputComponent } from './qty-input/qty-input.component';
import { ModalDetilPengirimanComponent } from './modal-detil-pengiriman/modal-detil-pengiriman.component';
import { ModalOpenFullimageComponent } from './modal-open-fullimage/modal-open-fullimage.component';
import { ModalSelectProvinsiComponent } from './modal-select-provinsi/modal-select-provinsi.component';
import { ModalSelectKecamatanComponent } from './modal-select-kecamatan/modal-select-kecamatan.component';
import { ImgFallbackModule } from '../directives/img-fallback.module';
import { ModalChangeLanguageComponent } from './modal-change-language/modal-change-language.component';
import { ProductRatingCardComponent } from './product-rating-card/product-rating-card.component';
import { ModalWelcomeComponent } from './modal-welcome/modal-welcome.component';
import { ModalCompleteAccountComponent } from './modal-complete-account/modal-complete-account.component';
import { HeaderDesktopComponent } from './header-desktop/header-desktop.component';
import { FooterDesktopComponent } from './footer-desktop/footer-desktop.component';
import { PersonalPageWrapperComponent } from './personal-page-wrapper/personal-page-wrapper.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { CategorySidebarWrapperComponent } from './category-sidebar-wrapper/category-sidebar-wrapper.component';
import { CategorySidebarMenuItemComponent } from './category-sidebar-menu-item/category-sidebar-menu-item.component';
import { ChatPopupButtonComponent } from './chat-popup-button/chat-popup-button.component';
import { ChatroomContentComponent } from './chatroom-content/chatroom-content.component';
import { ChatroomFooterComponent } from './chatroom-footer/chatroom-footer.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ErrorMessagesComponent,
    ModalLocationPickerComponent,
    ModalSelectCityComponent,
    ModalSelectWarehouseComponent,
    LocationPickerComponent,
    NoDataComponent,
    PasswordToggleComponent,
    ProductCardComponent,
    ProductCategoryBlurbComponent,
    ProductCheckoutComponent,
    ProductCheckoutLoadingComponent,
    AlamatCardComponent,
    AlamatCardLoadingComponent,
    CardTransaksiComponent,
    ProductCardDetailTransaksiComponent,
    PaymentCardComponent,
    PaymentCardLoadingComponent,
    EventCardComponent,
    VoucherCardComponent,
    ModalPaymentMethodComponent,
    ModalManualTransferPaymentComponent,
    MyVoucherCardComponent,
    StarReviewProductComponent,
    CircularProgressbarComponent,
    BlogCardComponent,
    ModalBarcodeComponent,
    HeaderComponent,
    SectionTitleComponent,
    HomeProductComponent,
    ProductReviewItemComponent,
    ModalCustomAlertComponent,
    ModalSelectStockLocationComponent,
    ModalSortComponent,
    ModalFilterComponent,
    ModalSelectCityBranchComponent,
    ModalQuickselectAlamatComponent,
    CategoryCardComponent,
    NavigatedSearchbarComponent,
    WishlistProductCardComponent,
    CartItemComponent,
    CheckoutItemComponent,
    OrderStepsComponent,
    ModalSelectPickupLocationComponent,
    CopyComponent,
    ModalShowPaymentDetailComponent,
    PointHistoryComponent,
    ModalSelectFilePaymentProofComponent,
    FakturCardComponent,
    ModalGetReasonComponent,
    CountdownComponent,
    OrderProductsComponent,
    PopoverWishlistSortFilterComponent,
    VoucherListComponent,
    TransactionSummaryComponent,
    QtyInputComponent,
    ModalDetilPengirimanComponent,
    ModalOpenFullimageComponent,
    ModalSelectProvinsiComponent,
    ModalSelectKecamatanComponent,
    ModalChangeLanguageComponent,
    ProductRatingCardComponent,
    ModalWelcomeComponent,
    ModalCompleteAccountComponent,
    HeaderDesktopComponent,
    FooterDesktopComponent,
    PersonalPageWrapperComponent,
    BreadcrumbsComponent,
    CategorySidebarWrapperComponent,
    CategorySidebarMenuItemComponent,
    ChatPopupButtonComponent,
    ChatroomContentComponent,
    ChatroomFooterComponent,
  ],
  exports: [
    ErrorMessagesComponent,
    ModalLocationPickerComponent,
    ModalSelectCityComponent,
    ModalSelectWarehouseComponent,
    LocationPickerComponent,
    NoDataComponent,
    PasswordToggleComponent,
    ProductCardComponent,
    ProductCategoryBlurbComponent,
    ProductCheckoutComponent,
    ProductCheckoutLoadingComponent,
    AlamatCardComponent,
    AlamatCardLoadingComponent,
    CardTransaksiComponent,
    ProductCardDetailTransaksiComponent,
    PaymentCardComponent,
    PaymentCardLoadingComponent,
    EventCardComponent,
    VoucherCardComponent,
    ModalPaymentMethodComponent,
    ModalManualTransferPaymentComponent,
    MyVoucherCardComponent,
    StarReviewProductComponent,
    CircularProgressbarComponent,
    BlogCardComponent,
    ModalBarcodeComponent,
    HeaderComponent,
    SectionTitleComponent,
    HomeProductComponent,
    ProductReviewItemComponent,
    ModalCustomAlertComponent,
    ModalSelectStockLocationComponent,
    ModalSortComponent,
    ModalFilterComponent,
    ModalSelectCityBranchComponent,
    ModalQuickselectAlamatComponent,
    CategoryCardComponent,
    NavigatedSearchbarComponent,
    WishlistProductCardComponent,
    CartItemComponent,
    CheckoutItemComponent,
    OrderStepsComponent,
    ModalSelectPickupLocationComponent,
    CopyComponent,
    ModalShowPaymentDetailComponent,
    PointHistoryComponent,
    ModalSelectFilePaymentProofComponent,
    FakturCardComponent,
    ModalGetReasonComponent,
    CountdownComponent,
    OrderProductsComponent,
    PopoverWishlistSortFilterComponent,
    VoucherListComponent,
    TransactionSummaryComponent,
    QtyInputComponent,
    ModalDetilPengirimanComponent,
    ModalOpenFullimageComponent,
    ModalSelectProvinsiComponent,
    ModalSelectKecamatanComponent,
    ModalChangeLanguageComponent,
    ProductRatingCardComponent,
    ModalWelcomeComponent,
    ModalCompleteAccountComponent,
    HeaderDesktopComponent,
    FooterDesktopComponent,
    PersonalPageWrapperComponent,
    BreadcrumbsComponent,
    CategorySidebarWrapperComponent,
    CategorySidebarMenuItemComponent,
    ChatPopupButtonComponent,
    ChatroomContentComponent,
    ChatroomFooterComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    FormsModule,
    ScrollingModule,
    RouterModule,
    ImgFallbackModule,
  ],
})
export class ComponentsModule {}
